const getMaxBreakpoint = bp => `@media (max-width: ${bp}px)`;
const getMinBreakpoint = bp => `@media (min-width: ${bp}px)`;
const getResponsiveBreakpoint = bp => `@media (max-width: ${bp}px)`;

export const Mobile = getMaxBreakpoint(992);
export const Desktop = getMinBreakpoint(993);
export const Phone = getResponsiveBreakpoint(768);
